(() => {
  if (window.DaniChouHomepageVariety) return;
  const keyboardBound = new WeakSet();

  const handleOf = (element) => {
    const link = element.matches('a[href]') ? element : element.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      return decodeURIComponent(new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] || '');
    } catch {
      return '';
    }
  };

  const visible = (element, show) => {
    element.hidden = !show;
    if (show) element.style.removeProperty('display');
    else element.style.setProperty('display', 'none', 'important');
  };

  const apply = () => {
    const used = new Set();
    const summary = { hero: [], duo: [], gifts: [], rows: [] };
    document.querySelectorAll('.dch-hero--collage .dch-hero-item').forEach((card) => {
      const handle = handleOf(card);
      if (handle) {
        used.add(handle);
        summary.hero.push(handle);
      }
    });

    document.querySelectorAll('.dch-duo').forEach((section) => {
      const card = section.querySelector('.dch-duo-card');
      const finder = section.querySelector('.dch-duo-finder');
      if (!card) return;
      const handles = Array.from(card.querySelectorAll('.dch-duo-item'), handleOf);
      const show = handles.length === 2 && handles.every(Boolean) && new Set(handles).size === 2 && handles.every((handle) => !used.has(handle));
      visible(card, show);
      section.querySelector('.dch-duo-wrap')?.classList.toggle('dch-duo-wrap--single', !show || !finder);
      visible(section, show || Boolean(finder));
      if (show) handles.forEach((handle) => { used.add(handle); summary.duo.push(handle); });
    });

    const allocate = (container, selector, limit) => {
      const selected = [];
      container.querySelectorAll(selector).forEach((card) => {
        const handle = handleOf(card);
        const show = Boolean(handle) && selected.length < limit && !used.has(handle);
        visible(card, show);
        if (show) {
          used.add(handle);
          selected.push(handle);
        }
      });
      return selected;
    };

    document.querySelectorAll('.dch-gift-prods[data-dch-limit]').forEach((list) => {
      const handles = allocate(list, ':scope > li', Number(list.dataset.dchLimit) || 0);
      visible(list, handles.length > 0);
      summary.gifts.push(...handles);
    });

    document.querySelectorAll('.dch-prod').forEach((section) => {
      const panels = Array.from(section.querySelectorAll('.dch-prod-panel[data-dch-limit]'));
      const available = [];
      panels.forEach((panel) => {
        const handles = allocate(panel, '.dch-prod-item', Number(panel.dataset.dchLimit) || 0);
        const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
        if (tab) visible(tab, handles.length > 0);
        panel.hidden = handles.length === 0;
        panel.style.removeProperty('display');
        if (handles.length) available.push({ panel, tab });
        summary.rows.push({ id: panel.id, label: tab?.textContent.trim() || '', handles });
      });
      const active = available.find(({ tab }) => tab?.getAttribute('aria-selected') === 'true') || available[0];
      available.forEach(({ panel, tab }) => {
        const selected = panel === active?.panel;
        panel.hidden = !selected;
        panel.style.removeProperty('display');
        if (tab) {
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        }
      });
      const tablist = section.querySelector('[role="tablist"]');
      if (tablist) visible(tablist, available.length > 1);
      section.classList.toggle('dch-prod--single', available.length === 1);
      visible(section, available.length > 0);
      if (!keyboardBound.has(section)) {
        keyboardBound.add(section);
        section.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          const tabs = Array.from(section.querySelectorAll('[role="tab"]')).filter((item) => !item.hidden);
          const index = tabs.indexOf(tab);
          if (index < 0 || !tabs.length) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          tabs[next].click();
          tabs[next].focus();
        }, true);
      }
    });
    return summary;
  };

  window.DaniChouHomepageVariety = { apply };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(apply));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(apply));
  document.addEventListener('shopify:section:reorder', () => requestAnimationFrame(apply));
})();
